import * as React from "react"
import { Grid } from "@mui/material"

import AdminScrapingDataReviewRawTable from "./RawTable"


export default function AdminScrapingDataReviewContent() {
    return <Grid container spacing={2}>
        <Grid item xs={12}>
            <AdminScrapingDataReviewRawTable />
        </Grid>
    </Grid>
}